/**
 * Small-screen shell: on phones everything secondary lives behind a tab bar
 * and opens as ONE sheet at a time — bottom sheet in portrait, right dock in
 * landscape. Desktop layout is untouched (this no-ops on large screens).
 */
const SHEETS: { key: string; label: string; panelId: string }[] = [
  { key: 'overview', label: '☰', panelId: 'overview' },
  { key: 'ship', label: '▲', panelId: 'ship' },
  { key: 'chat', label: '✉', panelId: 'chat' },
  { key: 'steps', label: '✓', panelId: 'firststeps' },
];

export class MobileShell {
  private mq = matchMedia('(max-width: 820px), (max-height: 520px)');
  private bar: HTMLElement | null = null;
  active: string | null = null;

  constructor() {
    this.apply();
    this.mq.addEventListener('change', () => this.apply());
    addEventListener('resize', () => this.orient());
    // Picking a target from the overview sheet should reveal the target panel
    document.addEventListener('click', (e) => {
      if (!this.isMobile() || this.active !== 'overview') return;
      if ((e.target as HTMLElement).closest?.('.ovrow')) this.setSheet(null);
    });
  }

  private orient(): void {
    document.body.classList.toggle('portrait', innerHeight >= innerWidth);
    document.body.classList.toggle('landscape', innerWidth > innerHeight);
  }

  isMobile(): boolean {
    return this.mq.matches;
  }

  private apply(): void {
    const on = this.mq.matches;
    document.body.classList.toggle('mobile', on);
    this.orient();
    if (on && !this.bar) this.buildBar();
    if (!on) {
      this.setSheet(null);
      this.bar?.remove();
      this.bar = null;
      document.body.classList.remove('portrait', 'landscape');
    }
  }

  private buildBar(): void {
    this.bar = document.createElement('div');
    this.bar.id = 'mtabs';
    for (const s of SHEETS) {
      const b = document.createElement('button');
      b.textContent = s.label;
      b.dataset.sheet = s.key;
      b.title = s.key;
      b.addEventListener('click', () => this.setSheet(this.active === s.key ? null : s.key));
      this.bar.appendChild(b);
    }
    // Absorb the standalone launcher buttons so the top edge stays clean
    for (const id of ['codexbtn', 'mapbtn', 'reachbtn', 'mutebtn']) {
      const el = document.getElementById(id);
      if (el) this.bar.appendChild(el);
    }
    document.body.appendChild(this.bar);
  }

  setSheet(key: string | null): void {
    this.active = key;
    document.body.dataset.sheet = key ?? 'none';
    this.bar?.querySelectorAll('button[data-sheet]').forEach((b) => {
      b.classList.toggle('primary', (b as HTMLElement).dataset.sheet === key);
    });
  }
}
